module.exports = __webpack_public_path__ + "static/media/jobs-banner.dd714989.png";